var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.125 26.25V0H0V43.75H21.5625V48.75H17.25V51.25H40.25V60H69V26.25H66.125ZM40.25 48.75H24.4375V43.75H40.25V48.75ZM40.25 41.25H2.875V36.25H40.25V41.25ZM40.25 33.75H2.875V2.5H63.25V26.25H40.25V33.75ZM66.125 57.5H43.125V53.75H66.125V57.5ZM66.125 51.25H43.125V33.75H66.125V51.25ZM66.125 31.25H43.125V28.75H66.125V31.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0952 7.5H16.6443V5H7.1875V13.2239H10.0625V9.26758L18.79 16.8567L20.8227 15.0891L12.0952 7.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 21.7767V25.7324L14.2726 18.1433L12.2399 19.9109L20.9673 27.5H16.4176V30H25.8751V21.7767H23.0001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 60,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintain);
export default __webpack_public_path__ + "static/media/Maintain.40f037236ee796f0e0d0b26de8cb7dcb.svg";
export { ForwardRef as ReactComponent };